module.exports = __webpack_public_path__ + "img/labmem_text_btnnext_jp.9dda4d67.png";